import { Input } from "../../../../Common/AbstractComponents/Input";

export class TravelDays {
    constructor({ insuranceForm, state }) {
        this.$insuranceForm = insuranceForm;
        this._state = state;

        this.$daysInput = $(this.$insuranceForm).find('input[name="days"]');
        this._input = new Input({
            input: this.$daysInput,
            event: 'input',
            handler: this._handler.bind(this),
        });
    }

    _handler(event) {
        const value = Number(event.target.value.replace(/[^0-9]/g, ''));

        $(event.target).val(value);
        this._state.days = value;
    }
}